const Pause = () => {
  return (
    <svg width="24" height="24" viewBox="4 4 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path id="rect3136" d="m 4,4 8,0 0,24 -8,0 z m 16,0 8,0 0,24 -8,0 z" fill="#678299" />
    </svg>
  );
};

export default Pause;
